import React, { useEffect, useRef, useState } from "react";
import './CheckoutPayCard.scss';
import { IonContent, IonLoading, IonLabel, IonInput, IonDatetime, IonSpinner, IonToast } from "@ionic/react";
import { Formik, Field, FieldProps } from "formik";
import moment from "moment";
import Button from "./Button";
import { ChecoutInitResponse, ErrorIcon } from "./CheckoutPayCard";
import { cardCheckoutSchema, cardCheckoutSchemav2 } from "../helpers/formValidationHelpers";
import { baseUrl } from "../helpers/configHelper";
import { ApplicationState } from "../store";
import { useSelector } from "react-redux";
import { useWindowSize } from "../helpers/useWindowSize";
import useWorldPay from "../helpers/useWorldPay";

declare global {
    interface Window {
        Worldpay: any
    }
}

const CheckoutCardPayWorldpay: React.FC = () => {

    const [toast, setToast] = useState<{ isToastOpen: boolean, toastMessage?: string | undefined }>({ isToastOpen: false });
    const [checkoutFormInvalid, setCheckoutFormInvalid] = useState<boolean | undefined>();

    const { initCheckoutSdk, checkoutRef, CreatePayment, isPageLoading } = useWorldPay();

    const [isPayLoading, setIsPayLoading] = useState(false);
    

    // fetch InitCheckout for environment variables then load Worldpay library
    useEffect(() => {
        initCheckoutSdk(() =>{ console.log("Checkout ready")});
    }, [])

    useEffect(() => {
        //console.log("isPayLoading", isPayLoading);
    }, [isPayLoading]);

    const onSubmit = (name: string) => {
        if(checkoutRef.current){
            checkoutRef.current.generateSessionState(function (error: any, sessionHref: any) {
                if (error) {
                    setCheckoutFormInvalid(true);
                    console.log(error);
                    return;
                } else {
                    setCheckoutFormInvalid(false);
                }
                setIsPayLoading(true);
                CreatePayment({ name, sessionHref, type: "card", 
                    onSuccess: () => {
                        setIsPayLoading(false);
                    },
                    onError: (error) => {
                        setToast({
                            isToastOpen: true,
                            toastMessage: error
                        });
                        setIsPayLoading(false);
                    } 
                });
            });
        } else {
            console.log("Unable to generate session, checkoutRef is null");
        }
    }

    return(
        <IonContent>
                <div className="CheckoutPayCard__wrapper">
                    <IonLoading isOpen={isPageLoading} message={"Please wait..."}/>
                    {
                        !isPageLoading &&
                        <div>

                            <Formik
                                initialValues={{Name: window.localStorage.getItem("nickname") ?? ""}}
                                validationSchema={cardCheckoutSchemav2}
                                onSubmit={(values, {}) => {
                                    onSubmit(values.Name);
                                }}>
                                {props => (
                                    <form id="card-form" onSubmit={props.handleSubmit} className="Checkout__form">
                                        <Field name="Name">
                                            {({ field, form, meta }: FieldProps) => (
                                                <div>
                                                    <IonLabel>Name on card<span className="required">*</span></IonLabel>
                                                    <IonInput className={`nameInput ${meta?.error && " error-border"}`} name={field.name} value={field.value} onIonChange={field.onChange}
                                                        enterkeyhint="next" autoCapitalize="true" autofocus={true} inputMode="text" placeholder="Joe Bloggs"/>
                                                    {meta?.error && <div className="field-error-message"><ErrorIcon/>{meta?.error}</div>}
                                                </div>
                                            )}
                                        </Field>

                                        <div className="number-outer">
                                            <IonLabel>Card number<span className="required">*</span></IonLabel>
                                            <section id="card-pan" className={`form-control` }></section>
                                        </div>

                                        {/* 
                                        <Field name="Expiry">
                                            {({ field, form, meta }: FieldProps) => (
                                                <div>
                                                    <IonLabel>Expiry date<span className="required">*</span></IonLabel>
                                                    <IonDatetime
                                                        className={`${meta?.error && " error-border"}`}

                                                        name={field.name} value={field.value} onIonChange={field.onChange} min={moment().format('YYYY')} max={moment().add(10, 'y').format('YYYY')} displayFormat="MM/YY" placeholder="MM/YY"/>
                                                    {meta?.error && <div className="field-error-message"><ErrorIcon/>{meta?.error}</div>}
                                                </div>
                                            )}
                                        </Field>
                                        */}

                                        <div className="expiry-outer">
                                            <IonLabel>Expiry date<span className="required">*</span></IonLabel>
                                            <div id="card-expiry" className={`form-control`}></div>
                                        </div>

                                        <div className="cvv-outer">
                                            <IonLabel>CVV<span className="required">*</span></IonLabel>
                                            <div id="card-cvv" className={`form-control` }></div>
                                        </div>

                                        { checkoutFormInvalid &&
                                            <div className="field-error-message">Payment form is invalid or incomplete</div>
                                        }
                                        

                                        <div className="pay-footer-container">
                                            <div className="pay-footer">
                                                <div className='pay-button-wrapper'>
                                                    <Button
                                                        color='secondary'
                                                        size="large"
                                                        expand='block'
                                                        type="submit"
                                                        disabled={isPayLoading}
                                                        rounded
                                                    >
                                                        {isPayLoading ? <IonSpinner /> : "Pay"}
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                )}
                            </Formik>

                            <IonToast
                                cssClass="card-payment-toast"
                                isOpen={toast.isToastOpen}
                                duration={10000}
                                message={toast.toastMessage}
                                onDidDismiss={(e) => {
                                    setToast({ isToastOpen: false, toastMessage: undefined });
                                }}/>
                        </div>
                    }
                </div>
            </IonContent>
    )
}

export default CheckoutCardPayWorldpay;